import { Version } from '@repo/toolkit/types'
import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { AAKeyword, AAKeywordSort } from '../../lib/types/models/aa-keywords/aa-keyword'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getAAKeywords(
  input: PaginationRequest<null, string, Version, AAKeywordSort> = {}
) {
  if (!input.sort) input.sort = { label: 'asc' }
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.aAKeyWords.getAll.url, null), input))
    .get<PaginationResponse<AAKeyword>>()
}
